import React, { useState } from 'react';
import { Modal } from 'antd';
import { connect } from 'dva';
import classes from './IntroductionCarousel.css';
import { router } from 'umi';
import { PATH_DASHBOARD } from '@/utils/routes/path';

const WELCOME_MODAL_IMAGES = [
  '/WelcomeModalImage1.png',
  '/WelcomeModalImage2.png',
  '/WelcomeModalImage3.png',
  '/WelcomeModalImage4.png',
  '/WelcomeModalImage5.png',
];

const RELEASE_MODAL_IMAGES = [
  '/WelcomeModalImage1.png',
  '/WelcomeModalImage2.png',
  '/WelcomeModalImage3.png',
  '/WelcomeModalImage4.png',
  '/WelcomeModalImage5.png',
];

const IntroductionCarousel = props => {
  const {
    modalData,
    currentUser,
    showNewReleaseModal,
    newReleaseModal,
    welcomeModal,
    allCloudAccountsList,
    dispatch,
  } = props;

  const {
    haveSeenReleaseModal = false,
    haveSeenWelcomeModal = false,
    ChangeAutoGeneratePassword,
  } = currentUser;

  const [isModalVisible, setIsModalVisible] = useState(true);
  const [currentSlide, setCurrentSlide] = useState(0);

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    const data = showModalData();
    if (data === welcomeModal && !haveSeenWelcomeModal) {
      dispatch({ type: 'user/update', payload: { haveSeenWelcomeModal: true } });
    } else if (data === newReleaseModal && !haveSeenReleaseModal) {
      dispatch({ type: 'user/update', payload: { haveSeenReleaseModal: true } });
    }
    setIsModalVisible(false);
  };

  const handleNext = () => {
    const data = showModalData();
    if (currentSlide < data.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      if (showModalData() === welcomeModal) {
        dispatch({ type: 'user/update', payload: { haveSeenWelcomeModal: true } });
      } else if (showModalData() === newReleaseModal) {
        dispatch({ type: 'user/update', payload: { haveSeenReleaseModal: true } });
      }
      if (!allCloudAccountsList.length) {
        router.push(PATH_DASHBOARD.setup.cloudAccountsAdd);
      }

      setIsModalVisible(false);
    }
  };

  const handlePrevious = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  const showModalData = () => {
    if (
      (ChangeAutoGeneratePassword || ChangeAutoGeneratePassword === undefined) &&
      !haveSeenWelcomeModal
    ) {
      return welcomeModal;
    }
    if (showNewReleaseModal && haveSeenWelcomeModal && !haveSeenReleaseModal) {
      return newReleaseModal;
    }
    return [];
  };

  const nextButtonText = (data, currentSlide) => {
    if (currentSlide < data?.length - 1) {
      return 'Next';
    } else if (allCloudAccountsList.length === 0) {
      return 'Add Cloud Account';
    } else {
      return 'Finish';
    }
  };

  const data = showModalData();
  const images = data === welcomeModal ? WELCOME_MODAL_IMAGES : RELEASE_MODAL_IMAGES;

  if (!data?.length) return null;

  return (
    <div>
      <Modal
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        closable={false}
        footer={null}
        bodyStyle={{
          maxHeight: '75vh',
          padding: '-4px',
        }}
      >
        <div
          style={{
            overflow: 'scroll',
            maxHeight: '70vh',
          }}
        >
          {data.length > 0 && (
            <div className={classes.modalContentDiv}>
              <img
                src={images[currentSlide]}
                alt={data[currentSlide]?.title || 'Slide Image'}
                style={{
                  maxWidth: '100%',
                }}
              />

              {/* Dots Navigation */}
              <div className={classes.dotsContainer}>
                {data.map((_, index) => (
                  <span
                    key={index}
                    className={`${classes.dot} ${currentSlide === index ? classes.activeDot : ''}`}
                    onClick={() => setCurrentSlide(index)}
                  />
                ))}
              </div>

              <div
                style={{
                  justifyContent: 'center',
                }}
              >
                <h5>{data[currentSlide].title}</h5>
                <p>{data[currentSlide].description}</p>
              </div>

              <div>
                {currentSlide > 0 && (
                  <button
                    className={`${classes.backButtonStyle} ${classes.btn}`}
                    onClick={handlePrevious}
                  >
                    <b>Back</b>
                  </button>
                )}
                <button
                  className={`${classes.nextButtonStyle} ${classes.btn}`}
                  onClick={handleNext}
                >
                  {nextButtonText(data, currentSlide)}
                </button>
              </div>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default connect(({ global, login, user, cloudAccount }) => ({
  newReleaseModal: global.modalData.newReleaseModal,
  welcomeModal: global.modalData.welcomeModal,
  currentUser: user.currentUser,
  showNewReleaseModal: login.showNewReleaseModal,
  allCloudAccountsList: cloudAccount.allCloudAccountsList,
}))(IntroductionCarousel);
